// Aperçu des champs qui seront pré-remplis sur la fiche adhérent lors de la
// conversion d'un prospect d'essai. IMPORTANT : ce helper reflète exactement
// les règles de `supabase/functions/trial-prospects/profilePrefill.ts`
// (buildProfilePrefill). À la conversion, un nouveau compte est créé : la
// fiche est vide, donc tous les champs fournis par le formulaire sont écrits.
// Toute modification des règles doit être faite des deux côtés.

export interface TrialPrefillSource {
  phone: string | null;
  clothing_size: string | null;
  notes: string | null;
  class_date: string | null;
  form_answers: Record<string, unknown> | null;
}

export interface PrefillPreviewItem {
  key: "phone" | "clothing_size" | "contraindications" | "notes";
  value: string;
}

const isEmpty = (v: unknown) => v === null || v === undefined || (typeof v === "string" && v.trim() === "");

function formatDate(iso: string | null): string {
  if (!iso) return new Date().toLocaleDateString("fr-FR");
  const [y, m, d] = iso.split("-");
  return `${d}/${m}/${y}`;
}

export function buildPrefillPreview(prospect: TrialPrefillSource): PrefillPreviewItem[] {
  const items: PrefillPreviewItem[] = [];

  if (!isEmpty(prospect.phone)) items.push({ key: "phone", value: String(prospect.phone).trim() });
  if (!isEmpty(prospect.clothing_size)) items.push({ key: "clothing_size", value: String(prospect.clothing_size).trim() });

  const answers = prospect.form_answers ?? {};
  const limitation = typeof answers.limitation_details === "string" ? answers.limitation_details.trim() : "";
  if (answers.has_limitation === true) {
    items.push({ key: "contraindications", value: limitation || "—" });
  }

  const notes = (prospect.notes ?? "").trim();
  if (notes) {
    items.push({ key: "notes", value: `Formulaire d'essai du ${formatDate(prospect.class_date)}\n${notes}` });
  }

  return items;
}
